import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SignInPage from "./pages/auth/sign-in";
import NotFoundPage from "./pages/not-found";
import SignUpPage from "./pages/auth/sign-up";
import MainPage from "./pages/main-page";
import ForgotPassword from "./pages/auth/forgot-password";
import ResetPassword from "./pages/auth/reset-password";
import EnterVerificationCode from "./pages/auth/enter-code";
import SettingsPage from "./pages/settings/main";
import PrivateRoute from "./components/private-route";
import AuthCallback from "./pages/auth/auth-callback";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "./assets/store";
import { refreshAccessToken } from "./assets/store/auth";
import ProjectsMainPage from "./pages/project/main";
import AddProjectPage from "./pages/project/add";
import DetailsProjectPage from "./pages/project/details";
import CompanyMainPage from "./pages/company/main";
import UpdateProjectPage from "./pages/project/update";
import AddCompanyPage from "./pages/company/add";
import DetailsCompanyPage from "./pages/company/details";
import UpdateCompanyPage from "./pages/company/update";
import ClientMainPage from "./pages/client/main";
import AddClientPage from "./pages/client/add";
import DetailsClientPage from "./pages/client/details";
import UpdateClientPage from "./pages/client/update";
import TaskMainPage from "./pages/task/main";
import AddTaskPage from "./pages/task/add";
import DetailsTaskPage from "./pages/task/details";
import SellingMainPage from "./pages/selling/main";
import UpdateTaskPage from "./pages/task/update";
import MainFinancePage from "./pages/finance/main";
import IncomeMainTab from "./pages/finance/income/main";
import ExpenseMainTab from "./pages/finance/expense/main";
import DetailsExpensePage from "./pages/finance/expense/details";
import DetailsIncomePage from "./pages/finance/income/details";
import AddExpensePage from "./pages/finance/expense/add";
import AddIncomePage from "./pages/finance/income/add";
import UpdateIncomePage from "./pages/finance/income/update";
import UpdateExpensePage from "./pages/finance/expense/update";
import AddSellingPage from "./pages/selling/add";
import DetailsSellingPage from "./pages/selling/details";
import UpdateSellingPage from "./pages/selling/update";
import ProfileSettingsTab from "./pages/settings/tabs/profile/profile-tab";
import ViewProfile from "./pages/settings/tabs/profile/view-profile";
import EditProfile from "./pages/settings/tabs/profile/edit-profile";
import GeneralSettingsTab from "./pages/settings/tabs/general";
import TeamUsersTab from "./pages/settings/tabs/team/team-users-tab";
import ViewTeam from "./pages/settings/tabs/team/view-team";
import AddMemberTeam from "./pages/settings/tabs/team/add-member-team";
import SendInviteTeam from "./pages/settings/tabs/team/send-invite-team";
import UpdateMemberTeam from "./pages/settings/tabs/team/update-member-team";
import DeleteTeamUserModal from "./pages/settings/tabs/team/delete-team-user-modal";
import OnboardingSettings from "./pages/auth/onboarding/settings";
import NameStep from "./pages/auth/onboarding/steps/name-step";
import StructureStep from "./pages/auth/onboarding/steps/structure-step";
import PlanStep from "./pages/auth/onboarding/steps/plan-step";
import FinishStep from "./pages/auth/onboarding/steps/finish-step";
import BasketSettingsTab from "./pages/settings/tabs/basket/main";
import ObjectsBasket from "./pages/settings/tabs/basket/objects";
import StructureSettingsTab from "./pages/settings/tabs/structure/main";
import ObjectStructureTab from "./pages/settings/tabs/structure/object";
import UpdateFieldStructureTab from "./pages/settings/tabs/structure/update-field";
import AddFieldStructureTab from "./pages/settings/tabs/structure/add-field";
import ManagementSettingsTab from "./pages/settings/tabs/management/main";
import PaymentSettingsTab from "./pages/settings/tabs/payment/main";
import PlanItemPaymentTab from "./pages/settings/tabs/payment/items/plan";
import TypeItemPaymentTab from "./pages/settings/tabs/payment/items/type";
import HistoryItemPaymentTab from "./pages/settings/tabs/payment/items/history";
import PlansLitsPage from "./pages/settings/tabs/payment/items/plans-list";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  return (
    <>
      <Routes location={location.state?.background || location}>
        <Route path="sign-in" element={<SignInPage />} />
        <Route path="sign-up" element={<SignUpPage />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="enter-code" element={<EnterVerificationCode />} />
        <Route
          path="onboarding"
          element={
            <OnboardingSettings />
          }
        >
          <Route index element={<Navigate to="name" replace />} />
          <Route path="name" element={<NameStep />} />
          <Route path="structure" element={<StructureStep />} />
          <Route path="plan" element={<PlanStep />} />
          <Route path="finish" element={<FinishStep />} />
        </Route>
        <Route
          path="main"
          element={
            <PrivateRoute>
              <MainPage />
            </PrivateRoute>
          }
        />
        <Route path="projects">
          <Route
            index
            path="main"
            element={
              <PrivateRoute>
                <ProjectsMainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="add"
            element={
              <PrivateRoute>
                <AddProjectPage />
              </PrivateRoute>
            }
          />
          <Route
            path="details/:id"
            element={
              <PrivateRoute>
                <DetailsProjectPage />
              </PrivateRoute>
            }
          />
          <Route
            path="update/:id"
            element={
              <PrivateRoute>
                <UpdateProjectPage />
              </PrivateRoute>
            }
          />
        </Route>
        <Route
          path="settings"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="profile" replace />} />
          <Route path="general" element={<GeneralSettingsTab />} />
          <Route path="management" element={<ManagementSettingsTab />} />
          <Route path="payment" element={<PaymentSettingsTab />}>
            <Route path="" element={<Navigate to="plan" />} />
            {/* <Route path="projects" element={<ProjectsBasket />} /> */}
            <Route path=":plan" element={<PlanItemPaymentTab />} />
            <Route path=":type" element={<TypeItemPaymentTab />} />
            <Route path=":history" element={<HistoryItemPaymentTab />} />
          </Route>
          <Route path="profile" element={<ProfileSettingsTab />}>
            <Route index element={<ViewProfile />} />
            <Route path="view" element={<ViewProfile />} />
            <Route path="edit" element={<EditProfile />} />
          </Route>

          <Route path="structure" element={<StructureSettingsTab />} />
          <Route path="structure/:id" element={<ObjectStructureTab />}>

          </Route>
          <Route path="structure/:id/update" element={<UpdateFieldStructureTab />} />
          <Route path="structure/:id/add" element={<AddFieldStructureTab />} />
          <Route path="team" element={<TeamUsersTab />}>
            <Route index element={<ViewTeam />} />
            <Route path="view" element={<ViewTeam />} />
            <Route path="add" element={<AddMemberTeam />} />
            <Route path="update/:id" element={<UpdateMemberTeam />} />
            <Route path="send-invite" element={<SendInviteTeam />} />
          </Route>
          <Route path="basket" element={<BasketSettingsTab />}>
            <Route path="" element={<Navigate to="projects" />} />
            {/* <Route path="projects" element={<ProjectsBasket />} /> */}
            <Route path=":id" element={<ObjectsBasket />} />
            <Route path=":expense" element={<ObjectsBasket />} />
            <Route path=":income" element={<ObjectsBasket />} />
            {/* {panelItems.slice(1, panelItems.length - 1).reverse().map((item) =>
            )} */}
          </Route>
        </Route>
        <Route path="plans" element={<PlansLitsPage />} />

        <Route path="companies">
          <Route
            index
            path="main"
            element={
              <PrivateRoute>
                <CompanyMainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="add"
            element={
              <PrivateRoute>
                <AddCompanyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="details/:id"
            element={
              <PrivateRoute>
                <DetailsCompanyPage />
              </PrivateRoute>
            }
          />

          <Route
            path="update/:id"
            element={
              <PrivateRoute>
                <UpdateCompanyPage />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="clients">
          <Route
            index
            path="main"
            element={
              <PrivateRoute>
                <ClientMainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="add"
            element={
              <PrivateRoute>
                <AddClientPage />
              </PrivateRoute>
            }
          />
          <Route
            path="details/:id"
            element={
              <PrivateRoute>
                <DetailsClientPage />
              </PrivateRoute>
            }
          />
          <Route
            path="update/:id"
            element={
              <PrivateRoute>
                <UpdateClientPage />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="tasks">
          <Route
            index
            path="main"
            element={
              <PrivateRoute>
                <TaskMainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="add"
            element={
              <PrivateRoute>
                <AddTaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="details/:id"
            element={
              <PrivateRoute>
                <DetailsTaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="update/:id"
            element={
              <PrivateRoute>
                <UpdateTaskPage />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="selling">
          <Route
            index
            path="main"
            element={
              <PrivateRoute>
                <SellingMainPage />
              </PrivateRoute>
            }
          />

          <Route
            path="add"
            element={
              <PrivateRoute>
                <AddSellingPage />
              </PrivateRoute>
            }
          />

          <Route
            path="details/:id"
            element={
              <PrivateRoute>
                <DetailsSellingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="update/:id"
            element={
              <PrivateRoute>
                <UpdateSellingPage />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="finance"
          element={
            <PrivateRoute>
              <MainFinancePage />
            </PrivateRoute>
          }
        >
          <Route path="income/main" element={<IncomeMainTab />} />
          <Route path="" element={<Navigate to="income/main" />} />
          <Route path="expense/main" element={<ExpenseMainTab />} />
        </Route>

        <Route
          path="finance/expense/details/:id"
          element={
            <PrivateRoute>
              <DetailsExpensePage />
            </PrivateRoute>
          }
        />

        <Route
          path="finance/income/details/:id"
          element={
            <PrivateRoute>
              <DetailsIncomePage />
            </PrivateRoute>
          }
        />

        <Route
          path="finance/expense/add"
          element={
            <PrivateRoute>
              <AddExpensePage />
            </PrivateRoute>
          }
        />

        <Route
          path="finance/income/add"
          element={
            <PrivateRoute>
              <AddIncomePage />
            </PrivateRoute>
          }
        />

        <Route
          path="finance/income/update/:id"
          element={
            <PrivateRoute>
              <UpdateIncomePage />
            </PrivateRoute>
          }
        />

        <Route
          path="finance/expense/update/:id"
          element={
            <PrivateRoute>
              <UpdateExpensePage />
            </PrivateRoute>
          }
        />

        <Route path="auth/callback" element={<AuthCallback />} />

        <Route path="" element={<Navigate to="/settings" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {location.state?.background && (
        <Routes>
          <Route
            path="/settings/team/delete/:id"
            element={<DeleteTeamUserModal />}
          />
        </Routes>
      )}</>
  );
}

export default App;
